import { h } from 'hyperapp';
export default (({
  text
}) => h("div", {
  class: "mdui-dialog-title"
}, text));